const BASE = process.env.NEXT_PUBLIC_BASE_URL ?? "";

/**
 * Cacheable image URL for a piece.
 *
 * Public by design — customer photos go through presigned URLs, but a shop
 * window has to be reachable without a session and crawlable by search.
 *
 * The version token is the row's updatedAt. It changes when a master is
 * re-ingested, which gives the new picture a new URL instead of waiting out
 * whatever the old one is cached for. It also rescues browsers holding a bad
 * response from before caching was fixed: those are keyed to the old URL and a
 * versioned one steps around them.
 */
export function artworkImageUrl(
  slug: string,
  size: "thumb" | "display" = "display",
  version?: string,
): string {
  const v = version ? `&v=${encodeURIComponent(String(version).slice(0, 24))}` : "";
  return `${BASE}/artwork/${encodeURIComponent(slug)}/image?size=${size}${v}`;
}
